import Helper from './Helper';

class ScrollDown {
  constructor() {
    this.headerImg = document.querySelector('.ns-header-img');
    this.scrollDownButton = document.querySelector('.ns-header__scroll-btn');
    if (this.headerImg != null && this.scrollDownButton != null ) {
      this.headerImgHeight = this.headerImg.offsetHeight;
      this.bindEvents()
    }
  }

  bindEvents() {
    this.scrollDownButton.addEventListener('click', (e) =>{
      window.scrollBy({
        top: this.headerImgHeight,
        left: 0,
        behavior: "smooth"
      });
    });
  }
}

export default ScrollDown;
